import { type SalesView } from "../../sales-views-context";

export const overviewRevenueAndRoas = {
  id: "overview_revenue_and_roas",
  name: "Overview: Revenue and ROAS",
  isTemplate: true,
  data: {
    filters: {
      attributionModel: "northbeam_custom",
      attributionWindow: "1",
      nbAccountingMode: "accrual",
      granularity: "platform",
      timeGranularity: "daily",
      dateRange: "last7Days",
      compareDateRange: "lastPeriod",
      breakdowns: [
        {
          key: "Platform (Northbeam)",
          values: [],
        },
      ],
    },
    columnConfigurations: [
      {
        name: "Rev",
        width: 120,
        visible: true,
      },
      {
        name: "MER",
        width: 120,
        visible: true,
      },
      {
        name: "Name",
        width: 450,
        visible: true,
      },
      {
        name: "Spend",
        width: 180,
        visible: true,
      },
      {
        name: "Attributed Rev",
        width: 182,
        visible: true,
      },
      {
        name: "ROAS",
        width: 120,
        visible: true,
      },
      {
        name: "LTV ROAS",
        width: 120,
        visible: true,
      },
      {
        name: "LTV CAC",
        width: 120,
        visible: true,
      },
      {
        name: "CTR",
        width: 120,
        visible: true,
      },
      {
        name: "CPM",
        width: 120,
        visible: true,
      },
      {
        name: "eCPC",
        width: 120,
        visible: true,
      },
    ],
    selectedMetricBoxes: [
      "Spend",
      "Attributed Rev",
      "Rev",
      "MER",
      "ROAS",
      "CAC",
      "LTV CAC",
      "LTV ROAS",
    ],
  },
} as unknown as SalesView;
